import $ from "jquery"
import "slick-carousel-latest"

/** Story Section */
$('.js-story-slider').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    const storySliderActiveCount = $('.js-story-slider .slick-active .slider__year').length;
    const storySliderCurrentCount = (currentSlide ? currentSlide : 0) + storySliderActiveCount;

    if(storySliderCurrentCount == storySliderActiveCount){
        $('.slick-arrow.slick-prev').addClass('slick-arrow--disable');
    }else{
        $('.slick-arrow.slick-prev').removeClass('slick-arrow--disable');
    }

    if(storySliderCurrentCount == slick.slideCount){
        $('.slick-arrow.slick-next').addClass('slick-arrow--disable');
    }else{
        $('.slick-arrow.slick-next').removeClass('slick-arrow--disable');
    }

    $('.js-slick-year').empty();

    $('.js-story-slider .slick-active .slider__year').each(function(){
        const sliderYear = $(this).text().replace(/[^0-9]/gi, '');
        
        $('.js-slick-year').append('<span>' + parseInt(sliderYear, 10) + '</span>');
    });
});

$('.js-story-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: $('.story__slider-nav .slick-prev'),
    nextArrow: $('.story__slider-nav .slick-next'),
    infinite: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 481,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

const storySliderCountNotClone = $('.js-story-slider .slick-slide').not('.slick-cloned').length;
let slickSliderGoToCount = storySliderCountNotClone - 3;

if( $(window).outerWidth() <= '991' ){
    slickSliderGoToCount = storySliderCountNotClone - 2;
}

if( $(window).outerWidth() <= '480' ){
    slickSliderGoToCount = storySliderCountNotClone - 1;
}

$('.js-story-slider').slick('slickGoTo', slickSliderGoToCount);

/** Content Potential Section */
$('.js-content-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: $('.content__slider-nav .slick-prev'),
    nextArrow: $('.content__slider-nav .slick-next'),
});

/** Shorts Section */
$('.js-shorts-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
        {
            breakpoint: 1640,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: $('.shorts__slider-nav .slick-prev'),
                nextArrow: $('.shorts__slider-nav .slick-next'),
            }
        },
        {
            breakpoint: 670,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: $('.shorts__slider-nav .slick-prev'),
                nextArrow: $('.shorts__slider-nav .slick-next'),
            }
        }
    ]
});

/** Photos Section */
$('.js-photo-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
    ]
});

/** Brands Section */
let brandsSliderCounter = $('.js-brands-counter');

$('.js-brands-slider').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    let i = (currentSlide ? currentSlide : 0) + 1;
    brandsSliderCounter.text(i + '/' + slick.slideCount);
});

$('.js-brands-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: $('.brands__slider-nav .slick-prev'),
    nextArrow: $('.brands__slider-nav .slick-next, .js-next-click'),
    infinite: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

/** Solution Section */
let solutionSliderCounter = $('.js-solution-counter');

$('.js-solution-slider').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    let i = (currentSlide ? currentSlide : 0) + 1;
    solutionSliderCounter.text(i + '/' + slick.slideCount);
});

$('.js-solution-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: $('.solution__slider-nav .slick-prev'),
    nextArrow: $('.solution__slider-nav .slick-next, .js-next-click'),
    infinite: true,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});